import React from "react";
import { Col, Row } from "react-bootstrap";
import CurrencyFormat from '../../Helpers/Formatters/CurrencyFormat';

export default function QuoteResultsSection(props) {
  return (
    <Col>
      <Row className="quote-result-header">
        {!props.loading &&
          <div id="estimates">
            <strong className="bold" >ESTIMATES FOR</strong>
            <div className="quote-result-title"> <CurrencyFormat number={props.budgetAmount} whole /> per month</div>
          </div>
        }
        {props.loading && <span className="quote-result-title estimate">Loading...</span>}

      </Row>
      <Row aria-labelledby="estimates">
        {props.quotes}
      </Row>
    </Col>
  )
}


// WEBPACK FOOTER //
// ./src/components/Tools/BudgetBasedQuoter/QuoteResultsSection.js